<section class="stacksBlockContainer" id="block-floating-social">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>

  <!-- Sidebar -->
  <div *ngIf="checkSidebar()" class="blockSidebar" (click)="appendBlock($event)">
    <img src="assets/images/blocks/button.png" alt="" srcset="" />
    <p>{{ 'Floating Social' | translate }}</p>
  </div>

  <!-- Mobile Preview -->
  <div class="previewFloatingSocial previewMobile" *ngIf="checkPreview()" id="{{ 'blockid' + blockId }}" [cdkDragData]="blockId" cdkDrag>
    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId)">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon>open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" (click)="deleteBlock(blockId)">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="blockPlaceholder" *cdkDragPlaceholder></div>

    <div class="floatingSocialPreview">
      <div class="socialIconsList">
        <div
          *ngFor="let social of getBlockFields(blockId)?.data?.socials"
          class="socialIconItem"
          [style.background-color]="getPlatformColor(social.platform)"
          [title]="getPlatformLabel(social.platform)"
        >
          <span class="platformIcon" [innerHTML]="getPlatformIcon(social.platform)"></span>

        </div>
      </div>
      <div class="floatingMainBtn" [style.background-color]="getBlockFields(blockId)?.style?.['background-color'] || '#567EDC'">
        <mat-icon>chat_bubble_outline</mat-icon>
      </div>
    </div>
  </div>

  <!-- Data Tab -->
  <div class="previewFields" *ngIf="checkData()">
    <h4 class="listTitle">{{ 'Social Media Links' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li *ngFor="let social of getBlockFields(blockId)?.data?.socials; let i = index" class="socialItem">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Platform' | translate }}</mat-label>
          <mat-select [value]="social.platform" (selectionChange)="socialPlatformChange(blockId, i, $event)">
            <mat-option *ngFor="let p of socialPlatforms" [value]="p.value">{{ p.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'URL' | translate }}</mat-label>
          <input matInput [value]="social.url" (keyup)="socialUrlChange(blockId, i, $event)" placeholder="https://" />
        </mat-form-field>
        <button class="stacksBtn red" (click)="removeSocial(blockId, i)">
          <mat-icon>delete</mat-icon>
          {{ 'Remove' | translate }}
        </button>
        <mat-divider></mat-divider>
      </li>
    </ul>
    <button class="stacksBtn green addSocialBtn" (click)="addSocial(blockId)">
      <mat-icon>add</mat-icon>
      {{ 'Add Social' | translate }}
    </button>
  </div>

  <!-- Style Tab -->
  <div class="styleFields" *ngIf="checkStyle()">
    <h4 class="listTitle">{{ 'General Settings' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Position' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('position-x', blockId, $event, 'select')" [value]="getBlockFields(blockId)?.style?.['position-x'] || 'right'">
          <mat-option value="right">{{ 'Right' | translate }}</mat-option>
          <mat-option value="left">{{ 'Left' | translate }}</mat-option>
        </mat-select>
      </li>
      <li class="contentCenter contentContainerColor">
        <label>{{ 'Button Color' | translate }}</label>
        <mat-form-field>
          <p class="colorPickerValue">{{ getBlockFields(blockId)?.style?.['background-color'] }}</p>
          <label for="floatingSocialColor" class="colorLabel">
            <input
              type="color"
              id="floatingSocialColor"
              matInput
              class="colorPicker"
              name="color"
              (change)="styleChange('background-color', blockId, $event, 'text')"
              [value]="getBlockFields(blockId)?.style?.['background-color'] || '#567EDC'"
            />
          </label>
        </mat-form-field>
      </li>
    </ul>
    <h4 class="listTitle">{{ 'Margins' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Margin Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="200" min="0" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['margin-bottom']?.slice(0, -2) }}" (change)="styleChange('margin-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="200" min="0" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['margin-right']?.slice(0, -2) }}" (change)="styleChange('margin-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
  </div>
</section>
